// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3OOnS","title":"ClientReferral_title__31zmo","itemText":"ClientReferral_itemText__25feF"};